'use strict';

var Util = require("../layouts/util.js");
var React = require("react");
var Gatsby = require("../gatsby.js");
var ReasonReact = require("reason-react/src/ReasonReact.js");
var LogoSvg = require("../assets/logo.svg");
var NavigationModuleScss = require("./navigation.module.scss");

var component = ReasonReact.statelessComponent("Navigation");

function make(pathName, $staropt$star, _) {
  var navigationLocation = $staropt$star ? $staropt$star[0] : /* Header */0;
  return /* record */[
          /* debugName */component[/* debugName */0],
          /* reactClassInternal */component[/* reactClassInternal */1],
          /* handedOffState */component[/* handedOffState */2],
          /* willReceiveProps */component[/* willReceiveProps */3],
          /* didMount */component[/* didMount */4],
          /* didUpdate */component[/* didUpdate */5],
          /* willUnmount */component[/* willUnmount */6],
          /* willUpdate */component[/* willUpdate */7],
          /* shouldUpdate */component[/* shouldUpdate */8],
          /* render */(function () {
              var isHomePage = pathName === "/";
              var rootClassName = navigationLocation ? NavigationModuleScss.root_footer : NavigationModuleScss.root_header;
              var match = navigationLocation === /* Header */0;
              var activeClassName = match ? /* Some */[NavigationModuleScss.link_active] : /* None */0;
              var match$1 = navigationLocation === /* Header */0;
              var ticketsClassName = match$1 ? /* Some */[NavigationModuleScss.ticketsButton] : /* None */0;
              var tmp = {
                href: "https://ti.to/reason-conf/reason-conf-2018",
                target: "_blank"
              };
              if (ticketsClassName) {
                tmp.className = ticketsClassName[0];
              }
              return React.createElement("nav", {
                          className: rootClassName
                        }, Util.componentOrNull(!isHomePage, ReasonReact.element(/* None */0, /* None */0, Gatsby.Link[/* make */0]("/", /* Some */[NavigationModuleScss.link_home], /* None */0, /* None */0, /* array */[React.createElement("img", {
                                            className: NavigationModuleScss.logo,
                                            alt: "Home",
                                            src: LogoSvg
                                          })]))), React.createElement("ul", {
                              className: NavigationModuleScss.list
                            }, React.createElement("li", {
                                  className: NavigationModuleScss.listItem
                                }, ReasonReact.element(/* None */0, /* None */0, Gatsby.Link[/* make */0]("/schedule/#day3", /* Some */[NavigationModuleScss.link], /* None */0, activeClassName, /* array */[Util.s("Schedule")]))), React.createElement("li", {
                                  className: NavigationModuleScss.listItem
                                }, ReasonReact.element(/* None */0, /* None */0, Gatsby.Link[/* make */0]("/speakers/", /* Some */[NavigationModuleScss.link], /* None */0, activeClassName, /* array */[Util.s("Speakers")]))), React.createElement("li", {
                                  className: NavigationModuleScss.listItem
                                }, ReasonReact.element(/* None */0, /* None */0, Gatsby.Link[/* make */0]("/attendees/", /* Some */[NavigationModuleScss.link], /* None */0, activeClassName, /* array */[Util.s("For Attendees")]))), React.createElement("li", {
                                  className: NavigationModuleScss.listItem
                                }, ReasonReact.element(/* None */0, /* None */0, Gatsby.Link[/* make */0]("/sponsors/", /* Some */[NavigationModuleScss.link], /* None */0, activeClassName, /* array */[Util.s("For Sponsors")]))), React.createElement("li", {
                                  className: NavigationModuleScss.listItem
                                }, ReasonReact.element(/* None */0, /* None */0, Gatsby.Link[/* make */0]("/jobs/", /* Some */[NavigationModuleScss.link], /* None */0, activeClassName, /* array */[Util.s("Jobs")]))), React.createElement("li", {
                                  className: NavigationModuleScss.listItem
                                }, ReasonReact.element(/* None */0, /* None */0, Gatsby.Link[/* make */0]("/about/", /* Some */[NavigationModuleScss.link], /* None */0, activeClassName, /* array */[Util.s("About")]))), React.createElement("li", {
                                  className: NavigationModuleScss.listItemBuy
                                }, React.createElement("a", tmp, Util.s("Buy a ticket")))));
            }),
          /* initialState */component[/* initialState */10],
          /* retainedProps */component[/* retainedProps */11],
          /* reducer */component[/* reducer */12],
          /* subscriptions */component[/* subscriptions */13],
          /* jsElementWrapped */component[/* jsElementWrapped */14]
        ];
}

var Link = 0;

exports.Link = Link;
exports.component = component;
exports.make = make;
/* component Not a pure module */



// WEBPACK FOOTER //
// ./src/components/navigation.js